<template>
  <div>
    <h5 class="headline">{{ $t("contract.parties.headline") }}</h5>
    <p class="bold">
      <span class="user-output">
        {{ $t("contract.parties.intro", { date: agreementDate }) }}</span
      >
    </p>
    <table style="width: 100%">
      <tr>
        <td>
          <p>
            <span class="user-output">{{ distributorName }}</span>
            <br />
            <span>{{ $t("contract.parties.label.cvr") }}</span>
            <span class="user-output">{{ distributorCvr }}</span>
            <br />
            <span class="user-output">{{ distributorAddress }}</span>
            <br />
            <span class="user-output">{{ distributorZipCity }}</span>
            <br />
            <span class="user-output">{{ distributorCountry }}</span>
            <br />
            <span class="callname">{{
              $t("contract.parties.label.distributor")
            }}</span>
          </p>
        </td>
      </tr>
    </table>

    <p class="bold">{{ $t("contract.parties.and") }}</p>
    <table style="width: 100%">
      <tr>
        <td>
          <p>
            <span class="user-output">{{ supplierName }}</span>
            <br />
            <span>{{ $t("contract.parties.label.cvr") }}</span>
            <span class="user-output">{{ supplierCvr }}</span>
            <br />
            <span class="user-output">{{ supplierAddress }}</span>
            <br />
            <span class="user-output">{{ supplierZipCity }}</span>
            <br />
            <span class="user-output">{{ supplierCountry }}</span>
            <br />
            <span class="callname">{{
              $t("contract.parties.label.supplier")
            }}</span>
          </p>
        </td>
      </tr>
    </table>

    <p class="bold">{{ $t("contract.parties.end") }}</p>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    distributor() {
      return this.$store.state.contract.parties.distributor;
    },
    supplier() {
      return this.$store.state.contract.parties.supplier;
    },
    agreementDate() {
      let date = this.$store.state.contract.contractDetails.agreementDate;
      return date !== ""
        ? this.$store.state.contract.contractDetails.agreementDate
        : this.$t("contract.parties.placeholder.date");
    },
    distributorName() {
      return this.distributor.name !== ""
        ? this.distributor.name
        : this.$t("contract.parties.placeholder.name");
    },
    supplierName() {
      return this.supplier.name !== ""
        ? this.supplier.name
        : this.$t("contract.parties.placeholder.name");
    },
    distributorCvr() {
      return this.distributor.cvr !== ""
        ? this.distributor.cvr
        : this.$t("contract.parties.placeholder.cvr");
    },
    supplierCvr() {
      return this.supplier.cvr !== ""
        ? this.supplier.cvr
        : this.$t("contract.parties.placeholder.cvr");
    },
    distributorAddress() {
      return this.distributor.address !== ""
        ? this.distributor.address
        : this.$t("contract.parties.placeholder.address");
    },
    supplierAddress() {
      return this.supplier.address !== ""
        ? this.supplier.address
        : this.$t("contract.parties.placeholder.address");
    },
    distributorZipCity() {
      return this.distributor.zipCity !== ""
        ? this.distributor.zipCity
        : this.$t("contract.parties.placeholder.zip_city");
    },
    supplierZipCity() {
      return this.supplier.zipCity !== ""
        ? this.supplier.zipCity
        : this.$t("contract.parties.placeholder.zip_city");
    },
    distributorCountry() {
      return this.distributor.country !== ""
        ? this.distributor.country
        : this.$t("contract.parties.placeholder.country");
    },
    supplierCountry() {
      return this.supplier.country !== ""
        ? this.supplier.country
        : this.$t("contract.parties.placeholder.country");
    },
  },
};
</script>

<style scoped>
.callname {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/PartiesOutput.vue